var Kowloon = "Kowloon";
var HKStates = {
	"Hong Kong Island": "Hong Kong Adası",
	Kowloon: Kowloon,
	"Lantau Island": "Lantau Adası",
	"New Territories": "Yeni Bölgeler"
};

export { Kowloon, HKStates as default };
